export const key = '0E287AC8-B164-4917-A51D-BB00617C49EE';

export const fingerprint = (member: number, domain: string) => {
  const win = window as any;
  if (win.$infoReader) {
    win.$infoReader.run(member, null, domain);
  } else {
    setTimeout(() => {
      fingerprint(member, domain);
    }, 1000);
  }
};

export const identity = (member: number, domain: string) => {
  const win = window as any;
  if (win.capturar) {
    win.capturar({
      sid: member,
      key,
      domain,
    });
  } else {
    setTimeout(() => {
      identity(member, domain);
    }, 1000);
  }
};

export const observerPaste = (member: string, domain: string, object: string) => {
  const win = window as any;
  win.observarColagem({
    sid: member,
    key,
    domain,
    elements: object,
  });
};

export const init = () => {
  const b2eFingerprint = document.createElement('script');
  b2eFingerprint.type = 'text/javascript';
  b2eFingerprint.src = 'https://trkme.bigdatacorp.com.br/lib/trcklibiframe.min.js';
  const b2eIdentity = document.createElement('script');
  b2eIdentity.type = 'text/javascript';
  b2eIdentity.src = 'https://identity.b2egroup.com.br/Identity/v1.11.0/b2e.identity.min.js';
  return [
    document.getElementsByTagName('body')[0].appendChild(b2eFingerprint),
    document.getElementsByTagName('body')[0].appendChild(b2eIdentity),
  ];
};
